import { render, staticRenderFns } from "./registrationData.vue?vue&type=template&id=2dba6c6a&scoped=true"
import script from "./registrationData.vue?vue&type=script&lang=js"
export * from "./registrationData.vue?vue&type=script&lang=js"
import style0 from "./registrationData.vue?vue&type=style&index=0&id=2dba6c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba6c6a",
  null
  
)

export default component.exports